export const planMixin = {
  data() {
    return {
      slot: (mealTimeSlot) => {
        const slotId = (mealTimeSlot) => {
          switch (mealTimeSlot) {
            case 'Breakfast':
              return 1;
            case 'Lunch':
              return 2;
            case 'Dinner':
              return 3;
            case 'Snacks':
              return 4;
          }
        };

        return {
          id: slotId(mealTimeSlot),
          name: mealTimeSlot,
        };
      },
    };
  },
  methods: {
    getMealTime(mealTimeSlot) {
      return this.slot(mealTimeSlot);
    },
  },
};
